import { Bell, ChevronDown, LogOut, Menu, Shield } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminHeader = ({ onMenuClick, title, user }) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const { logout } = useAuth();
  const adminName = user?.name || user?.fullName || "Admin";
  const adminRole = user?.role || "admin";

  const handleLogout = () => {
    logout();
    navigate("/admin-login");
  };

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="sticky top-0 z-30 border-b border-[#d7dfd4] bg-[#f5f7f2]/92 backdrop-blur"
    >
      <div className="flex items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="rounded-2xl border border-slate-200 bg-white p-2.5 text-slate-600 transition-colors hover:bg-slate-50 lg:hidden"
          >
            <Menu className="h-5 w-5" />
          </button>

          <div>
            <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400">
              <span className="h-2 w-2 rounded-full bg-[#138808]" />
              JanShakti Control
            </div>
            <h1 className="mt-1 text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden items-center gap-2 rounded-full border border-[#cfe6d2] bg-[#edf8ef] px-4 py-2 md:flex">
            <Shield className="h-4 w-4 text-[#138808]" />
            <span className="text-sm font-medium text-[#106d06]">Admin secure session</span>
          </div>

          <button className="hidden rounded-2xl border border-slate-200 bg-white p-3 text-slate-500 transition-colors hover:bg-slate-50 md:inline-flex">
            <Bell className="h-4 w-4" />
          </button>

          <div className="relative">
            <button
              onClick={() => setShowDropdown((open) => !open)}
              className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-3 py-2.5 shadow-sm transition-colors hover:bg-slate-50"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-[#ff9933] via-[#f7c98a] to-[#138808] text-sm font-bold text-slate-900">
                {adminName.charAt(0)}
              </div>
              <div className="hidden text-left md:block">
                <p className="text-sm font-semibold text-slate-900">{adminName}</p>
                <p className="text-xs uppercase tracking-[0.18em] text-slate-500">{adminRole}</p>
              </div>
              <ChevronDown className="h-4 w-4 text-slate-400" />
            </button>

            {showDropdown && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="absolute right-0 mt-2 w-64 overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-xl shadow-slate-900/10"
              >
                <div className="border-b border-slate-100 bg-gradient-to-r from-[#fff1df] via-white to-[#edf8ef] px-5 py-4">
                  <p className="text-sm font-semibold text-slate-900">{adminName}</p>
                  <p className="mt-1 text-xs uppercase tracking-[0.18em] text-slate-500">{adminRole}</p>
                </div>
                <div className="p-2">
                  <button
                    onClick={handleLogout}
                    className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-left text-sm font-medium text-rose-600 transition-colors hover:bg-rose-50"
                  >
                    <LogOut className="h-4 w-4" />
                    Logout
                  </button>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default AdminHeader;
